import { Box, IconButton, Menu, MenuItem } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import React from 'react';
import moment from 'moment';

export const DISCOVERY_APP_USER_DASHBOARD_COLUMN = [
  {
    Header: 'Discovery Id Parent',
    accessor: '_id',
  },
  {
    Header: 'Name',
    accessor: 'name',
  },
  {
    Header: 'City',
    accessor: 'city',
  },
  {
    Header: 'App Download Date',
    accessor: 'appRegesterDate',
    Cell: (val) => {
      const payload = val.cell.row.original;
      const { appRegesterDate } = payload;
      return (
        <>
          {appRegesterDate ? moment(appRegesterDate).format('DD MMM YYYY') : ''}
        </>
      );
    },
  },
  { Header: 'In-app Earning', accessor: 'inAppEarning' },
  { Header: 'Referral Benifit Earned', accessor: 'referralBenefits' },
  { Header: 'City Leaderboard Rank', accessor: 'rank' },
  {
    Header: 'Action',
    accessor: '',
    Cell: () => {
      const [anchorEl, setAnchorEl] = React.useState(null);
      const open = Boolean(anchorEl);

      const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
      };

      const handleClose = () => {
        setAnchorEl(null);
      };
      const options = ['Suspend'];
      const ITEM_HEIGHT = 48;
      return (
        <>
          <Box display="flex">
            <Box
              width={80}
              // onClick={setDetails}
              // component={Link}
              // to={`${CONFIRM_ADMISSIONS_VIEW_DETAILS_ROUTE}?leadId=${leadId}&schoolId=${schoolId}&formId=${formId}`}
              fontSize={14}
              // className={classes.textStyle}
              // style={{ cursor: 'not-allowed' }}
            >
              {/* View */}
              <IconButton
                aria-label="more"
                aria-controls="long-menu"
                aria-haspopup="true"
                onClick={handleClick}>
                <MoreVertIcon />
              </IconButton>
              <Menu
                id="long-menu"
                anchorEl={anchorEl}
                keepMounted
                open={open}
                onClose={handleClose}
                PaperProps={{
                  style: {
                    maxHeight: ITEM_HEIGHT * 4.5,
                    width: '20ch',
                  },
                }}>
                {options.map((option) => (
                  <MenuItem
                    key={option}
                    selected={option === 'Pyxis'}
                    onClick={handleClose}>
                    {option}
                  </MenuItem>
                ))}
              </Menu>
            </Box>
          </Box>
        </>
      );
    },
  },
];
